"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyDomainInvalidError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "ApiKeyDomainInvalid";
const messageKey = "driver.apiKey.error.domainInvalid";
class ApiKeyDomainInvalidError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, constants_1.maxDomainPerApiKey),
        });
    }
}
exports.ApiKeyDomainInvalidError = ApiKeyDomainInvalidError;
//# sourceMappingURL=apiKeyDomainInvalid.js.map